import script from "./ShareLinkBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareLinkBox.vue?vue&type=script&setup=true&lang=js"

import "./ShareLinkBox.vue?vue&type=style&index=0&id=1f7960eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7960eb"]])

export default __exports__